{
  "identities.messages.1010001": "ግባ",
  "identities.messages.1010002": "በ{provider} ግባ",
  "identities.messages.1010003": "እርስዎ መሆንዎን በማረጋገጥ ይህን ድርጊት እባክዎን ያረጋግጡ።",
  "identities.messages.1010004": "እባክዎን ሁለተኛውን የማረጋገጫ ፈተና ያጠናቅቁ።",
  "identities.messages.1010005": "አረጋግጥ",
  "identities.messages.1010006": "የማረጋገጫ ኮድ",
  "identities.messages.1010007": "የመጠባበቂያ መልሶ ማግኛ ኮድ",
  "identities.messages.1010008": "በሃርድዌር ቁልፍ ቀጥል",
  "identities.messages.1010009": "ቀጥል",
  "identities.messages.1010010": "ቀጥል",
  "identities.messages.1010011": "በሃርድዌር ቁልፍ ግባ",
  "identities.messages.1010012": "የእርስዎን WebAuthn መሣሪያ (ለምሳሌ የደህንነት ቁልፍ፣ ባዮሜትሪክስ ስካነር፣ ...) ያዘጋጁ እና ቀጥል የሚለውን ይጫኑ።",
  "identities.messages.1010013": "ቀጥል",
  "identities.messages.1010014": "ኮድ ወደ ያቀረቡት አድራሻ ተልኳል። ካልደረስዎት እባክዎን የአድራሻውን ፊደል አጻጻፍ ይመርምሩ እና እንደገና ይሞክሩ።",
  "identities.messages.1010015": "የመግቢያ ኮድ ላክ",
  "identities.messages.1010016": "በ\"{duplicateIdentifier}\" ለመግባት ሞክረዋል፣ ነገር ግን ያ ኢሜይል አስቀድሞ በሌላ መለያ ጥቅም ላይ ውሏል። መለያዎን \"{duplicateIdentifier}\" በ\"{provider}\" እንደ ሌላ የመግቢያ መንገድ ለመጨመር ከታች ካሉት አማራጮች በአንዱ ወደ መለያዎ ይግቡ።",
  "identities.messages.1010017": "ግባ እና አገናኝ",
  "identities.messages.1010018": "በ{provider} አረጋግጥ",
  "identities.messages.1010019": "ለመቀጠል ኮድ ጠይቅ",
  "identities.messages.1010021": "በማለፊያ ቁልፍ ግባ",
  "identities.messages.1010022": "በይለፍ ቃል ግባ",
  "identities.messages.1010023": "ኮድ ወደ {address} ላክ",
  "identities.messages.1040001": "ተመዝገብ",
  "identities.messages.1040002": "በ{provider} ተመዝገብ",
  "identities.messages.1040003": "ቀጥል",
  "identities.messages.1040004": "በደህንነት ቁልፍ ተመዝገብ",
  "identities.messages.1040005": "ኮድ ወደ ያቀረቡት አድራሻ(ዎች) ተልኳል። መልእክት ካልደረስዎት የአድራሻውን ፊደል አጻጻፍ ይመርምሩ እና ምዝገባውን እንደገና ይሞክሩ።",
  "identities.messages.1040006": "የምዝገባ ኮድ ላክ",
  "identities.messages.1040007": "በማለፊያ ቁልፍ ተመዝገብ",
  "identities.messages.1040008": "ተመለስ",
  "identities.messages.1040009": "እባክዎን ራስዎን ለማረጋገጥ ምስክርነት ይምረጡ።",
  "identities.messages.1050001": "ለውጦችዎ ተቀምጠዋል!",
  "identities.messages.1050002": "{provider}ን አገናኝ",
  "identities.messages.1050003": "{provider}ን አላግባብ",
  "identities.messages.1050004": "TOTP ማረጋገጫ መተግበሪያን አላግባብ",
  "identities.messages.1050005": "የማረጋገጫ መተግበሪያ QR ኮድ",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "የመጠባበቂያ መልሶ ማግኛ ኮዶችን አሳይ",
  "identities.messages.1050008": "አንቃ",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "እነዚህ የእርስዎ የመጠባበቂያ መልሶ ማግኛ ኮዶች ናቸው። እባክዎን በደህንነት ቦታ ያስቀምጧቸው!",
  "identities.messages.1050011": "የመጠባበቂያ መልሶ ማግኛ ኮዶችን አረጋግጥ",
  "identities.messages.1050012": "የደህንነት ቁልፍ ጨምር",
  "identities.messages.1050013": "የደህንነት ቁልፍ ስም",
  "identities.messages.1050014": "ምስጢር በ{used_at, date, long} ጥቅም ላይ ውሏል",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "ይህን ዘዴ አሰናክል",
  "identities.messages.1050017": "የማረጋገጫ ምስጢር",
  "identities.messages.1050018": "የደህንነት ቁልፍ \"{display_name}\" አስወግድ",
  "identities.messages.1050019": "ማለፊያ ቁልፍ ጨምር",
  "identities.messages.1050020": "ማለፊያ ቁልፍ \"{display_name}\" አስወግድ",
  "identities.messages.1060001": "መለያዎን በተሳካ ሁኔታ መልሰው አግኝተዋል። እባክዎን የይለፍ ቃልዎን ይቀይሩ ወይም በሚቀጥሉት {privileged_session_expires_at_unix_until_minutes} ደቂቃዎች ውስጥ አማራጭ የመግቢያ ዘዴ ያዋቅሩ።",
  "identities.messages.1060002": "የመልሶ ማግኛ አገናኝ የያዘ ኢሜይል ወደ ያቀረቡት የኢሜይል አድራሻ ተልኳል። ኢሜይል ካልደረስዎት የአድራሻውን ፊደል አጻጻፍ ይመርምሩ እና ያመዘገቡበትን አድራሻ መጠቀምዎን ያረጋግጡ።",
  "identities.messages.1060003": "የመልሶ ማግኛ ኮድ የያዘ ኢሜይል ወደ ያቀረቡት የኢሜይል አድራሻ ተልኳል። ኢሜይል ካልደረስዎት የአድራሻውን ፊደል አጻጻፍ ይመርምሩ እና ያመዘገቡበትን አድራሻ መጠቀምዎን ያረጋግጡ።",
  "identities.messages.1060004": "የመልሶ ማግኛ ኮድ ወደ \"{masked_address}\" ተልኳል። ካልደረስዎት የአድራሻውን ፊደል አጻጻፍ ይመርምሩ እና ያመዘገቡበትን አድራሻ መጠቀምዎን ያረጋግጡ።",
  "identities.messages.1060005": "የመልሶ ማግኛ አድራሻዎን ሙሉ በሙሉ በመስጠት ወደ መለያዎ መዳረሻ መልሰው ያግኙ።",
  "identities.messages.1060006": "መለያዎን እንዴት መልሰው ማግኘት ይፈልጋሉ?",
  "identities.messages.1060007": "ተመለስ",
  "identities.messages.1070001": "የይለፍ ቃል",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "አስቀምጥ",
  "identities.messages.1070004": "መታወቂያ",
  "identities.messages.1070005": "አስገባ",
  "identities.messages.1070006": "ኮድ አረጋግጥ",
  "identities.messages.1070007": "ኢሜይል",
  "identities.messages.1070008": "ኮድ እንደገና ላክ",
  "identities.messages.1070009": "ቀጥል",
  "identities.messages.1070010": "የመልሶ ማግኛ ኮድ",
  "identities.messages.1070011": "የማረጋገጫ ኮድ",
  "identities.messages.1070012": "የምዝገባ ኮድ",
  "identities.messages.1070013": "የመግቢያ ኮድ",
  "identities.messages.1070014": "ግባ እና ምስክርነት አገናኝ",
  "identities.messages.1070015": "ለመቀጠል እባክዎን የካፕቻ ፈተናውን ይሙሉ።",
  "identities.messages.1070016": "የመልሶ ማግኛ አድራሻ",
  "identities.messages.1070017": "ስልክ ቁጥር",
  "identities.messages.1080001": "የማረጋገጫ አገናኝ የያዘ ኢሜይል ወደ ያቀረቡት የኢሜይል አድራሻ ተልኳል። ኢሜይል ካልደረስዎት የአድራሻውን ፊደል አጻጻፍ ይመርምሩ እና ያመዘገቡበትን አድራሻ መጠቀምዎን ያረጋግጡ።",
  "identities.messages.1080002": "የኢሜይል አድራሻዎን በተሳካ ሁኔታ አረጋግጠዋል።",
  "identities.messages.1080003": "የማረጋገጫ ኮድ የያዘ ኢሜይል ወደ ያቀረቡት የኢሜይል አድራሻ ተልኳል። ኢሜይል ካልደረስዎት የአድራሻውን ፊደል አጻጻፍ ይመርምሩ እና ያመዘገቡበትን አድራሻ መጠቀምዎን ያረጋግጡ።",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "እባክዎን {property} ያስገቡ እና እንደገና ይሞክሩ።",
  "identities.messages.4000003": "ርዝመት >= {min_length} መሆን አለበት፣ ግን {actual_length} አገኘሁ",
  "identities.messages.4000004": "ከስርዓት \"{pattern}\" ጋር አይመሳሰልም",
  "identities.messages.4000005": "የይለፍ ቃሉ {reason} ስለሆነ ጥቅም ላይ መዋል አይችልም።",
  "identities.messages.4000006": "የቀረቡት ምስክርነቶች የተሳሱ ናቸው፣ በይለፍ ቃልዎ ወይም በተጠቃሚ ስምዎ፣ በኢሜይል አድራሻዎ ወይም በስልክ ቁጥርዎ ውስጥ የፊደል አጻጻፍ ስህተቶችን ይመርምሩ።",
  "identities.messages.4000007": "ተመሳሳይ መለያ ያለው መለያ (ኢሜይል፣ ስልክ፣ ተጠቃሚ ስም፣ ...) አስቀድሞ አለ።",
  "identities.messages.4000008": "የቀረበው የማረጋገጫ ኮድ የተሳሳተ ነው፣ እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4000009": "ምንም የመግቢያ መለያዎችን ማግኘት አልቻልኩም። ማቀናበራቸውን ረስተዋል? ይህ በአገልጋይ የተሳሳተ ቅንብር ሊከሰት ይችላል።",
  "identities.messages.4000010": "መለያ ገና ንቁ አይደለም። የኢሜይል አድራሻዎን ማረጋገጥ ረስተዋል?",
  "identities.messages.4000011": "የTOTP መሣሪያ አላዘጋጁም።",
  "identities.messages.4000012": "ይህ የመጠባበቂያ መልሶ ማግኛ ኮድ አስቀድሞ ጥቅም ላይ ውሏል።",
  "identities.messages.4000013": "የWebAuthn መሣሪያ አላዘጋጁም።",
  "identities.messages.4000014": "የመጠባበቂያ መልሶ ማግኛ ኮዶች አላዘጋጁም።",
  "identities.messages.4000015": "ይህ መለያ የለም ወይም የደህንነት ቁልፍ አላዘጋጀም።",
  "identities.messages.4000016": "የመጠባበቂያ መልሶ ማግኛ ኮድ ልክ ያልሆነ ነው።",
  "identities.messages.4000017": "ርዝመት <= {max_length} መሆን አለበት፣ ግን {actual_length} አገኘሁ",
  "identities.messages.4000018": ">= {minimum} መሆን አለበት ግን {actual} አገኘሁ",
  "identities.messages.4000019": "> {minimum} መሆን አለበት ግን {actual} አገኘሁ",
  "identities.messages.4000020": "<= {maximum} መሆን አለበት ግን {actual} አገኘሁ",
  "identities.messages.4000021": "< {maximum} መሆን አለበት ግን {actual} አገኘሁ",
  "identities.messages.4000022": "{actual} የ{base} ማባዣ አይደለም",
  "identities.messages.4000023": "ከፍተኛው {max_items} ንጥሎች ተፈቅደዋል፣ ግን {actual_items} ንጥሎችን አገኘሁ",
  "identities.messages.4000024": "ዝቅተኛው {min_items} ንጥሎች ተፈቅደዋል፣ ግን {actual_items} ንጥሎችን አገኘሁ",
  "identities.messages.4000025": "በኢንዴክስ {index_a} እና {index_b} ያሉ ንጥሎች እኩል ናቸው",
  "identities.messages.4000026": "{allowed_types_list} ይጠበቃል፣ ግን {actual_type} አገኘሁ",
  "identities.messages.4000027": "ተመሳሳይ መለያ ያለው መለያ (ኢሜይል፣ ስልክ፣ ተጠቃሚ ስም፣ ...) አስቀድሞ አለ። እባክዎን ማህበራዊ መገለጫዎን ለማገናኘት ወደ ነባር መለያዎ ይግቡ።",
  "identities.messages.4000028": "በ{credential_identifier_hint} ለመግባት ሞክረዋል እሱም አስቀድሞ በሌላ መለያ ጥቅም ላይ ውሏል። {available_credential_types_list}ን በመጠቀም መግባት ይችላሉ። ከሚከተሉት ማህበራዊ መግቢያ አቅራቢዎች በአንዱ መግባት ይችላሉ፡ {available_oidc_providers_list}።",
  "identities.messages.4000029": "ከቋሚ {expected} ጋር እኩል መሆን አለበት",
  "identities.messages.4000030": "ቋሚ ወድቋል",
  "identities.messages.4000031": "የይለፍ ቃሉ ከመለያው ጋር በጣም ስለሚመሳሰል ጥቅም ላይ መዋል አይችልም።",
  "identities.messages.4000032": "የይለፍ ቃሉ ቢያንስ {min_length} ቁምፊዎች ረዥም መሆን አለበት፣ ግን {actual_length} አገኘሁ።",
  "identities.messages.4000033": "የይለፍ ቃሉ ከፍተኛው {max_length} ቁምፊዎች ረዥም መሆን አለበት፣ ግን {actual_length} አገኘሁ።",
  "identities.messages.4000034": "የይለፍ ቃሉ በመረጃ ጥሰቶች ተገኝቷል እና ከእንግዲህ ጥቅም ላይ መዋል የለበትም።",
  "identities.messages.4000035": "ይህ መለያ የለም ወይም በኮድ መግቢያን አላዘጋጀም።",
  "identities.messages.4000036": "የቀረቡት ባህሪያት ከዚህ ፍሰት ጋር በቀድሞ የተያያዙትን ባህሪያት አይመሳሰሉም።",
  "identities.messages.4000037": "ይህ መለያ የለም ወይም የተዋቀረ የመግቢያ ዘዴ የለውም።",
  "identities.messages.4000038": "የካፕቻ ማረጋገጫ ወድቋል፣ እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4010001": "ይህ ተግባር ጊዜው አለፈ። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4010002": "ለማስገባት ስልት ማግኘት አልቻልኩም። ቅጹን በትክክል ሞልተዋል?",
  "identities.messages.4010003": "ለመመዝገብ ስልት ማግኘት አልቻልኩም። ቅጹን በትክክል ሞልተዋል?",
  "identities.messages.4010004": "ቅንብሮችዎን ለማዘመን ስልት ማግኘት አልቻልኩም። ቅጹን በትክክል ሞልተዋል?",
  "identities.messages.4010005": "መለያዎን ለመልሶ ማግኘት ስልት ማግኘት አልቻልኩም። ቅጹን በትክክል ሞልተዋል?",
  "identities.messages.4010006": "መለያዎን ለማረጋገጥ ስልት ማግኘት አልቻልኩም። ቅጹን በትክክል ሞልተዋል?",
  "identities.messages.4010007": "ጥያቄው አስቀድሞ በተሳካ ሁኔታ ተጠናቅቋል እና እንደገና መሞከር አይቻልም።",
  "identities.messages.4010008": "የመግቢያው ኮድ የተሳሳተ ወይም አስቀድሞ ጥቅም ላይ ውሏል። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4010009": "የተገናኙ ምስክርነቶች አይመሳሰሉም።",
  "identities.messages.4010010": "ያስገቡት አድራሻ በአሁኑ መለያ ውስጥ ከታወቁ አድራሻዎች ጋር አይመሳሰልም።",
  "identities.messages.4040001": "ይህ ተግባር ጊዜው አለፈ። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4040002": "ጥያቄው አስቀድሞ በተሳካ ሁኔታ ተጠናቅቋል እና እንደገና መሞከር አይቻልም።",
  "identities.messages.4040003": "የምዝገባው ኮድ የተሳሳተ ወይም አስቀድሞ ጥቅም ላይ ውሏል። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4050001": "ይህ ተግባር ጊዜው አለፈ። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4060001": "ጥያቄው አስቀድሞ በተሳካ ሁኔታ ተጠናቅቋል እና እንደገና መሞከር አይቻልም።",
  "identities.messages.4060002": "የመልሶ ማግኛው ፍሰት የውድቀት ሁኔታ ላይ ደርሷል እና እንደገና መሞከር አለበት።",
  "identities.messages.4060004": "የመልሶ ማግኛው ቶከን የተሳሳተ ወይም አስቀድሞ ጥቅም ላይ ውሏል። እባክዎን ፍሰቱን እንደገና ይሞክሩ።",
  "identities.messages.4060005": "ይህ ተግባር ጊዜው አለፈ። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4060006": "የመልሶ ማግኛው ኮድ የተሳሳተ ወይም አስቀድሞ ጥቅም ላይ ውሏል። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4070001": "የማረጋገጫው ቶከን የተሳሳተ ወይም አስቀድሞ ጥቅም ላይ ውሏል። እባክዎን ፍሰቱን እንደገና ይሞክሩ።",
  "identities.messages.4070002": "ጥያቄው አስቀድሞ በተሳካ ሁኔታ ተጠናቅቋል እና እንደገና መሞከር አይቻልም።",
  "identities.messages.4070003": "የማረጋገጫው ፍሰት የውድቀት ሁኔታ ላይ ደርሷል እና እንደገና መሞከር አለበት።",
  "identities.messages.4070005": "ይህ ተግባር ጊዜው አለፈ። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4070006": "የማረጋገጫው ኮድ የተሳሳተ ወይም አስቀድሞ ጥቅም ላይ ውሏል። እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "ውጣ",
  "login.registration-button": "ተመዝገብ",
  "login.registration-label": "መለያ የለዎትም?",
  "login.title": "ግባ",
  "login.subtitle": "በ{parts} ግባ",
  "login.title-aal2": "ሁለተኛ ደረጃ ማረጋገጫ",
  "login.subtitle-aal2": "ሁለተኛ ደረጃ ማረጋገጫዎን ለማጠናቀቅ መንገድ ይምረጡ",
  "login.code.subtitle": "የማረጋገጫ ኮድ በኢሜይል ይላካል",
  "login.webauthn.subtitle": "እባክዎን የእርስዎን WebAuthn መሣሪያ ያዘጋጁ",
  "login.totp.subtitle": "እባክዎን በማረጋገጫ መተግበሪያዎ የተፈጠረውን ኮድ ያስገቡ",
  "login.lookup_secret.subtitle": "እባክዎን ከ8-አሃዝ የመጠባበቂያ መልሶ ማግኛ ኮዶችዎ አንዱን ያስገቡ",
  "login.title-refresh": "እንደገና አረጋግጥ",
  "login.subtitle-refresh": "ማንነትዎን በ{parts} አረጋግጥ",
  "login.2fa.go-back": "የሆነ ነገር እየሰራ አይደለም?",
  "login.2fa.go-back.link": "ተመለስ",
  "login.2fa.method.go-back": "ሌላ ዘዴ ምረጥ",
  "recovery.title": "መለያዎን መልሰው ያግኙ",
  "recovery.subtitle": "የአንድ ጊዜ መዳረሻ ኮድ ለመቀበል ከመለያዎ ጋር የተያያዘውን መለያ ያስገቡ",
  "registration.login-button": "ግባ",
  "registration.login-label": "አስቀድመው መለያ አለዎት?",
  "registration.title": "መለያ መዝግብ",
  "registration.subtitle": "በ{parts} ተመዝገብ",
  "settings.navigation-back-button": "ተመለስ",
  "settings.subtitle": "የመለያ ቅንብሮችዎን ያዘምኑ",
  "settings.title": "የመለያ ቅንብሮች",
  "settings.password.title": "የይለፍ ቃል ቀይር",
  "settings.password.description": "የይለፍ ቃልዎን ያስተካክሉ",
  "settings.profile.title": "የመገለጫ ቅንብሮች",
  "settings.profile.description": "የመገለጫ መረጃዎን ያዘምኑ",
  "settings.webauthn.title": "የሃርድዌር ቶከኖችን አስተዳድር",
  "settings.webauthn.description": "የሃርድዌር ቶከን ቅንብሮችዎን ያስተዳድሩ",
  "settings.messages.toast-title.success": "ቅንብሮች ዘምነዋል",
  "settings.messages.toast-title.error": "ቅንብሮችን ማዘመን አልተቻለም",
  "verification.title": "መለያዎን ያረጋግጡ",
  "verification.subtitle": "ለማረጋገጥ ከመለያዎ ጋር የተያያዘውን የኢሜይል አድራሻ ያስገቡ",
  "two-step.password.title": "የይለፍ ቃል",
  "two-step.password.description": "ከመለያዎ ጋር የተያያዘ የይለፍ ቃልዎን ያስገቡ",
  "two-step.code.title": "የኢሜይል ኮድ",
  "two-step.code.description": "የማረጋገጫ ኮድ ወደ ኢሜይልዎ ይላካል",
  "two-step.webauthn.title": "የደህንነት ቁልፍ",
  "two-step.webauthn.description": "ለማረጋገጥ የደህንነት ቁልፍዎን ይጠቀሙ",
  "two-step.passkey.title": "ማለፊያ ቁልፍ (የሚመከር)",
  "two-step.passkey.description": "ለጣት አሻራ ወይም ለፊት ማወቂያ የመሣሪያዎን ተጠቀሙ",
  "two-step.passkey.description.error": "ማለፊያ ቁልፍዎን ለመጠቀም አስፈላጊ ቤተ-መጻህፍትን መጫን አልተቻለም። እባክዎን በኋላ እንደገና ይሞክሩ።",
  "two-step.totp.title": "የማረጋገጫ መተግበሪያዎን ይጠቀሙ (TOTP)",
  "two-step.totp.description": "ከማረጋገጫ መተግበሪያዎ 6-አሃዝ የአንድ ጊዜ ኮድ ይጠቀሙ",
  "two-step.lookup_secret.title": "የመጠባበቂያ መልሶ ማግኛ ኮድ",
  "two-step.lookup_secret.description": "ለማረጋገጥ ከ8-አሃዝ የመጠባበቂያ ኮዶችዎ አንዱን ይጠቀሙ",
  "input.placeholder": "{placeholder}ዎን ያስገቡ",
  "card.header.parts.oidc": "ማህበራዊ አቅራቢ",
  "card.header.parts.password.registration": "{identifierLabel}ዎን እና የይለፍ ቃል",
  "card.header.parts.password.login": "{identifierLabel}ዎን እና የይለፍ ቃል",
  "card.header.parts.code": "የአንድ ጊዜ ኮድ",
  "card.header.parts.passkey": "ማለፊያ ቁልፍ",
  "card.header.parts.webauthn": "የደህንነት ቁልፍ",
  "card.header.parts.totp": "የማረጋገጫ መተግበሪያዎ",
  "card.header.parts.lookup_secret": "የመጠባበቂያ መልሶ ማግኛ ኮድ",
  "card.header.parts.identifier-first": "{identifierLabel}ዎን",
  "misc.or": "ወይም",
  "forms.label.forgot-password": "የይለፍ ቃል ረስተዋል?",
  "forms.label.recover-account": "መለያ መልሰው ያግኙ",
  "settings.totp.title": "ማረጋገጫ መተግበሪያ",
  "settings.totp.description": "የመለያ ደህንነትዎን ለማሻሻል የTOTP ማረጋገጫ መተግበሪያ ወደ መለያዎ ይጨምሩ። ታዋቂ ማረጋገጫ መተግበሪያዎች LastPass እና Google Authenticator ናቸው",
  "settings.totp.info.not-linked": "ለማንቃ QR ኮዱን በማረጋገጫዎ ይቃኙ እና ኮዱን ያስገቡ።",
  "settings.totp.info.linked": "በአሁኑ ጊዜ የተገናኘ ማረጋገጫ መተግበሪያ አለዎት።",
  "settings.lookup_secret.title": "የመጠባበቂያ መልሶ ማግኛ ኮዶች (ሁለተኛ ደረጃ)",
  "settings.lookup_secret.description": "የመልሶ ማግኛ ኮዶች ለ2FA ደህንነቱ የተጠበቀ መጠባበቂያ ሲሆኑ፣ 2FA መሣሪያዎን ካጡ መለያዎን እንደገና እንዲደርሱ ያስችሉዎታል።",
  "settings.oidc.title": "የተገናኙ መለያዎች",
  "settings.oidc.description": "የማህበራዊ መግቢያ አቅራቢን ከመለያዎ ጋር ያገናኙ።",
  "settings.oidc.info": "ከእነዚህ አቅራቢዎች የተገናኙ መለያዎች ወደ መለያዎ ለመግባት ሊያገለግሉ ይችላሉ",
  "settings.webauthn.info": "የሃርድዌር ቶከኖች ለሁለተኛ-ደረጃ ማረጋገጫ ወይም እንደ ማለፊያ ቁልፎች ለመጀመሪያ-ደረጃ ይጠቀማሉ",
  "settings.passkey.title": "ማለፊያ ቁልፎችን አስተዳድር",
  "settings.passkey.description": "የማለፊያ ቁልፍ ቅንብሮችዎን ያስተዳድሩ",
  "settings.passkey.info": "የማለፊያ ቁልፍ ቅንብሮችዎን ያስተዳድሩ",
  "card.footer.select-another-method": "ሌላ ዘዴ ምረጥ",
  "account-linking.title": "መለያ አገናኝ",
  "property.password": "የይለፍ ቃል",
  "property.email": "ኢሜይል",
  "property.phone": "ስልክ",
  "property.username": "ተጠቃሚ ስም",
  "property.identifier": "መለያ",
  "property.code": "ኮድ",
  "property.recovery_address": "የመልሶ ማግኛ አድራሻ",
  "consent.title": "{party}ን ፍቀድ",
  "consent.subtitle": "የሶስተኛ ወገን መተግበሪያ ከመለያዎ {identifier} ጋር የተያያዘ መረጃን ማግኘት ይፈልጋል።",
  "consent.scope.openid.title": "ማንነት",
  "consent.scope.openid.description": "መተግበሪያው ማንነትዎን እንዲያረጋግጥ ያስችለዋል። ይህ ለማረጋገጫ እና ለታመነ የመግቢያ ልምድ ያስፈልጋል።",
  "consent.scope.offline_access.title": "ከመስመር ውጭ መዳረሻ",
  "consent.scope.offline_access.description": "ይህ መተግበሪያ በንቃት እየተጠቀሙበት ባይሆንም እንኳ እንደ ገቡ ይቆዩ።",
  "consent.scope.profile.title": "የመገለጫ መረጃ",
  "consent.scope.profile.description": "የመጀመሪያ ስም፣ የአባት ስም እና የተጠቃሚ ስምዎን ጨምሮ ወደ መሠረታዊ የመገለጫ ዝርዝሮችዎ መዳረሻ ያስችላል።",
  "consent.scope.email.title": "የኢሜይል አድራሻ",
  "consent.scope.email.description": "የኢሜይል አድራሻዎን እና የማረጋገጫ ሁኔታውን ያግኙ።",
  "consent.scope.address.title": "አካላዊ አድራሻ",
  "consent.scope.address.description": "የፖስታ አድራሻዎን ያግኙ።",
  "consent.scope.phone.title": "የስልክ ቁጥር",
  "consent.scope.phone.description": "የስልክ ቁጥርዎን እና የማረጋገጫ ሁኔታውን ያግኙ።",
  "error.title.what-happened": "ምን ተከሰተ?",
  "error.title.what-can-i-do": "ምን ማድረግ እችላለሁ?",
  "error.instructions": "እባክዎን በጥቂት ደቂቃዎች ውስጥ እንደገና ይሞክሩ ወይም የድር ጣቢያውን አስተዳዳሪ ያነጋግሩ።",
  "error.footer.text": "ይህን ስህተት በሚዘግቡበት ጊዜ፣ እባክዎን የሚከተለውን መረጃ ያካትቱ፡",
  "error.footer.copy": "ቅዳ",
  "error.action.go-back": "ተመለስ",
  "identities.messages.4000039": "አዲሱ የይለፍ ቃል ከድሮው የይለፍ ቃል የተለየ መሆን አለበት።",
  "identities.messages.4000040": "ትክክለኛ የኢሜይል አድራሻ ያስገቡ",
  "identities.messages.4000041": "ትክክለኛ ስልክ ቁጥር ያስገቡ",
  "captcha.error": "የደህንነት ማረጋገጫ አልተሳካም። እባክዎ በኋላ እንደገና ይሞክሩ። ችግሩ ከቀጠለ ድጋፍን ያነጋግሩ።",
  "identities.messages.5000002": "ማንኛውንም የማንነት ማረጋገጫ ዘዴዎች አይገኙም። እባክዎ የስርዓት አስተዳዳሪውን ያግኙ።",
  "identities.messages.4010011": "ይህ አካውንት ለአገልግሎት ሊያቀርብ በማይችልበት ሁኔታ ተዘጋጅቷል። እባክዎን እርዳታ ለማግኘት የእገዛ አገልግሎት ጋር ያግኙ።",
  "identities.messages.1070018": "ኢሜይል ወይም የስልክ ቁጥር",
  "identities.messages.1080004": "የማረጋገጫ ኮድ ያለው የመልዕክት ሳጥን ወደ የሰጡት የስልክ ቁጥር ተልኳል። የመልዕክት ሳጥን ካላገኙ፣ የስልክ ቁጥሩን በትክክል መጻፉን ያረጋግጡ እና ለመመዝገብ የሰጡትን ቁጥር ይጠቀሙ።",
  "identities.messages.1080005": "የሞባይል ስልክ ቁጥራችሁን በትክክል አረጋግጣችኋል።",
  "identities.messages.5000003": "ድርጅትዎ ለሲንግል ሳይን-ኦን (SSO) ማረጋገጫ ያስፈልጋል፣ ነገር ግን ምንም አይነት SSO አገልግሎት አቅራቢ አልተዋቀረም። እባክዎ የስርዓት አስተዳዳሪውን ያነግጉ።",
  "identities.messages.1010024": "የመግቢያ ቁልፍ በመጠቀም ይግቡ።",
  "identities.messages.1010025": "ኮድ ወደ አድራሻዎ ተልኳል። ካልተቀበሉት፣ እባክዎ እንደገና ይሞክሩ።",
  "identities.messages.4000042": "የመሳሪያ ማረጋገጫ መሳሪያዎ አልተዋቀረም።",
  "identities.messages.4000043": "የተሰጠው የዌብ መታወቂያ ማስገቢያ ትክክል አይደለም፣ እባክዎን እንደገና ይሞክሩ።",
  "identities.messages.4000044": "የተሰጠው DeviceAuthn ፈረንሽ ትክክል አይደለም።",
  "identities.messages.4050002": "በአንድ ጊዜ አንድ አድራሻ ብቻ መለወጥ ይችላሉ። እባክዎን እያንዳንዱን አድራሻ በተናጥል ያስተካክሉ።"
}
